import { computed } from 'vue'
import { getRemainViewTime } from '@/common/utils/player.util'

export const useContentDetail = (contentInfo = {}) => {
  const actorList = computed(() => contentInfo?.actors?.list ?? [])
  const episodeNumber = computed(() =>
    (contentInfo?.episodenumber ?? '').replace('회', ''),
  )
  const episodeSynopsis = computed(() => contentInfo?.episodesynopsis ?? '')
  const episodeTitle = computed(() => contentInfo?.episodetitle ?? '')
  const hasActorList = computed(() => actorList.value.length > 0)
  const hasViewTime = computed(() => viewTime.value > 0)
  const remainViewTime = computed(() => {
    const { playtime = '0', viewtime = '0' } = contentInfo
    return getRemainViewTime(playtime, viewtime)
  })
  const seasonSynopsis = computed(() => contentInfo?.seasonsynopsis ?? '')
  const seasonTitle = computed(() => contentInfo?.seasontitle ?? '')
  const synopsis = computed(() => contentInfo?.synopsis ?? '')
  const viewRatio = computed(
    () => `${Number(contentInfo?.viewratio ?? '0') * 100}%`,
  )
  const viewTime = computed(() => Number(contentInfo?.viewtime ?? '0'))

  return {
    actorList,
    episodeNumber,
    episodeSynopsis,
    episodeTitle,
    hasActorList,
    hasViewTime,
    remainViewTime,
    seasonSynopsis,
    seasonTitle,
    synopsis,
    viewRatio,
    viewTime,
  }
}
